    document.addEventListener('DOMContentLoaded', function() {
      var newpricewithsvgs = document.querySelectorAll('.newpricewithsvg');
      var newsletter3_button = document.querySelectorAll('.custom-newsletter3-button');
      var appliMoudle3_link = document.querySelectorAll('.appliMoudle3-seemore_link');
      
      newpricewithsvgs.forEach(function(item) {
        item.addEventListener('mouseover', function() {
          item.classList.add('hovered');
        });

        item.addEventListener('mouseout', function() {
          item.classList.remove('hovered');
        });
      });
      newsletter3_button.forEach(function(item) {
        item.addEventListener('mouseover', function() {
          item.classList.add('hovered');
        });

        item.addEventListener('mouseout', function() {
          item.classList.remove('hovered');
        });
      });
      appliMoudle3_link.forEach(function(item) {
        item.addEventListener('mouseover', function() {
          item.classList.add('hovered');
        });

        item.addEventListener('mouseout', function() {
          item.classList.remove('hovered');
        });
      });
    });